/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Nav_For_WhomInputs */

const en_platform_nav_for_whom = /** @type {(inputs: Platform_Nav_For_WhomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who it's for`)
};

const pl_platform_nav_for_whom = /** @type {(inputs: Platform_Nav_For_WhomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla kogo`)
};

/**
* | output |
* | --- |
* | "Who it's for" |
*
* @param {Platform_Nav_For_WhomInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_nav_for_whom = /** @type {((inputs?: Platform_Nav_For_WhomInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Nav_For_WhomInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_nav_for_whom(inputs)
	return en_platform_nav_for_whom(inputs)
});